import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useSearchResultsContext } from "@/components/Search/SearchResults/context/searchResults.context";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";
import * as SearchSelectors from "@/redux/modules/value/search/search.selectors";
import { SearchComponent } from "@/utils/search/types/searchComponent";

import { ProductResultsContextProvider } from "./context/productResults.context";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    const dispatch = useThunkDispatch();
    const { showFacets } = useSearchResultsContext();

    const hasSelectedProductFacets = useSelector(
        SearchSelectors.hasSelectedFacets(SearchComponent.PRODUCT_FACETS)
    );

    const hasProductResults = useSelector(
        SearchSelectors.hasResults(SearchComponent.PRODUCT_NUMBER_OF_HITS)
    );

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        dispatch(CartModule.load());
    }, []);

    const renderProductResults = hasProductResults || hasSelectedProductFacets;

    if (!renderProductResults) {
        return null;
    }

    return (
        <ProductResultsContextProvider showFacets={!!showFacets}>
            {children}
        </ProductResultsContextProvider>
    );
};

export { Base };
